export default "__VITE_ASSET__DstO777D__"